import { get } from '@mindtickle/api-helpers';
import { BERRY_API_TOKEN_ENDPOINT } from './constant';

export async function getBerryAuthToken() {
  try {
    const response = await get({
      url: BERRY_API_TOKEN_ENDPOINT,
    });
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error>>>>:', error);
    return { token: '' };
  }
}

export const getBerryWidgetStyle = (isAdmin: boolean) => `
  #BerryappChatWidget iframe {
    ${isAdmin && 'position: absolute;'}
    ${!isAdmin && 'bottom: 24px !important'};
    min-height: 350px;
    box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.12) !important;
  }
  #BerryappChatWidget .berry-widget-toggle img,
  #BerryappChatWidget .berry-widget-toggle svg {
    width: 24px !important;
    height: 24px !important;
  }
`;
